export default __webpack_public_path__ + "static/media/congrats.0ac94fbb.svg";